import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function GoogleG() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path
                fill="#4285F4"
                d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"
            />
            <path
                fill="#34A853"
                d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.32A9 9 0 0 0 9 18z"
            />
            <path
                fill="#FBBC05"
                d="M3.97 10.72a5.41 5.41 0 0 1 0-3.44V4.96H.96a9 9 0 0 0 0 8.08l3.01-2.32z"
            />
            <path
                fill="#EA4335"
                d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59A9 9 0 0 0 .96 4.96l3.01 2.32C4.68 5.16 6.66 3.58 9 3.58z"
            />
        </svg>
    );
}

export default function Login() {
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;
        fetch(`${API}/auth/me`, { credentials: "include" })
            .then((res) => {
                if (res.ok && !cancelled) navigate("/admin", { replace: true });
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, [navigate]);

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const signIn = () => {
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
            window.location.origin + "/admin",
        )}`;
    };

    return (
        <div className="login-page" data-testid="login-page">
            <a href="/" className="back-link" data-testid="login-back-link">
                <ArrowLeft size={14} strokeWidth={1.5} /> Back to site
            </a>
            <div className="auth-card" data-testid="login-card">
                <div className="auth-seal">SFG</div>
                <div className="auth-kicker">SITE OWNER ACCESS</div>
                <h1 className="auth-title">Sign in to view enquiries</h1>
                <p className="auth-copy">
                    This area is private. Sign in with your Google account to
                    read enquiries submitted through the booking form.
                </p>
                <button
                    className="btn-google"
                    data-testid="login-google-button"
                    onClick={signIn}
                >
                    <GoogleG /> Continue with Google
                </button>
                <div className="auth-note">
                    Secured by Emergent managed Google sign-in · Sessions last
                    7 days
                </div>
            </div>
        </div>
    );
}
